import styled, { css } from 'styled-components';

export const tile = css`
  font-family: 'Inter', sans-serif;
  color: ${({ theme }) => theme.colors.neutral['700']};
  font-weight: 500;
  font-size: 14px;
  max-width: 100%;
  text-align: center;
  padding: 0.5em 0.5em;
  background: none;
  margin: 2px 0;
  height: 35px;
  line-height: normal;

  &:disabled {
    box-shadow: none;
    color: ${({ theme }) => theme.colors.neutral['500']};
    background: ${({ theme }) => theme.colors.neutral['100']};
    border-radius: 0;
    pointer-events: none;
  }

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.primary['100']};
    box-shadow: ${({ theme }) => `inset 0 0 0 1px ${theme.colors.primary['300']}`};
    border-radius: ${({ theme }) => `${theme.radii.medium}px`};
  }
`;

export const tileNow = css`
  background: ${({ theme }) => theme.colors.bg};
  box-shadow: ${({ theme }) => `inset 0 0 0 1px ${theme.colors.primary['300']}`};
  border-radius: ${({ theme }) => `${theme.radii.medium}px`};
`;

export const tileSelected = css`
  ${tile};
  background: ${({ theme }) => theme.colors.primary['500']};
  color: ${({ theme }) => theme.colors.bg};
  border-radius: ${({ theme }) => `${theme.radii.medium}px`};
  border: none;
  box-shadow: none;

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.primary['500']};
    color: ${({ theme }) => theme.colors.bg};
    border-radius: ${({ theme }) => `${theme.radii.medium}px`};
    box-shadow: none;
  }
`;

export const tileRangeActive = css`
  ${tile};
  background: ${({ theme }) => theme.colors.primary['100']};
  color: ${({ theme }) => theme.colors.primary['600']};
  box-shadow: none;
  border-radius: 0;

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.primary['100']};
    color: ${({ theme }) => theme.colors.primary['600']};
    box-shadow: ${({ theme }) => `inset 0 0 0 1px ${theme.colors.primary['300']}`};
    border-radius: ${({ theme }) => `${theme.radii.medium}px`};
  }
`;

export const tileRangeHover = css`
  ${tile};
  background: ${({ theme }) => theme.colors.neutral['200']};
`;

export const yearTile = css`
  box-shadow: ${({ theme }) => `inset 0 0 0 1px ${theme.colors.neutral['200']}`};
  border-radius: ${({ theme }) => `${theme.radii.medium}px`};
  font-weight: 500;
  font-size: 12px;
  flex-basis: 31.5% !important;
  margin: 2px;
  padding: 1.5em 0;
  height: auto;
  line-height: normal;
`;

export const CalendarWrapper = styled.div`
  display: inline-block;

  .react-calendar {
    box-sizing: border-box;
    width: 248px;
    max-width: 100%;
    background: white;
    font-family: 'Inter', sans-serif;
    line-height: 1.125em;

    &,
    & *,
    & *:before,
    & *:after {
      box-sizing: border-box;
    }

    button {
      margin: 0;
      border: 0;
      outline: none;
      cursor: pointer;
      text-shadow: none;
      height: auto;
      line-height: normal;
      border-radius: 0;

      &.react-calendar__tile {
        ${tile}

        &--now {
          ${tileNow}
        }

        &--active {
          ${tileRangeActive}
        }

        &--hasActive,
        &--rangeStart,
        &--rangeEnd {
          ${tileSelected}
        }
      }
    }

    &--selectRange {
      button.react-calendar__tile {
        &--hover {
          ${tileRangeHover}
        }

        &--rangeStart,
        &--rangeEnd {
          ${tileSelected}
        }

        &--hoverStart,
        &--hoverEnd {
          ${tileSelected}
        }
      }
    }

    &__navigation {
      display: flex;
      height: 32px;
      margin-bottom: 4px;
      display: flex;

      &__label {
        &__labelText {
          font-family: 'Inter', sans-serif;
          font-weight: 500;
          color: ${({ theme }) => theme.colors.neutral['700']};
          font-size: 14px;
        }
      }

      button {
        background: none;
        padding: 0 12px;

        i {
          margin: 0;
        }

        &:hover,
        &:focus {
          background: ${({ theme }) => theme.colors.neutral['200']};
        }

        &:disabled {
          pointer-events: none;

          .react-calendar__navigation__label__labelText {
            color: ${({ theme }) => theme.colors.neutral['400']};
          }

          i {
            color: ${({ theme }) => theme.colors.neutral['400']};
          }
        }
      }
    }

    &__month-view {
      &__weekdays {
        text-align: center;
        font-size: 12px;
        color: ${({ theme }) => theme.colors.neutral['500']};

        &__weekday {
          font-family: 'Inter', sans-serif;
          padding: 0.5em;

          abbr {
            text-decoration: none;
          }
        }
      }
    }

    button.react-calendar__year-view__months__month,
    button.react-calendar__decade-view__years__year,
    button.react-calendar__century-view__decades__decade {
      ${yearTile}

      &.react-calendar__tile--hasActive {
        box-shadow: none;
      }

      &:disabled {
        background: ${({ theme }) => theme.colors.neutral['100']};
        box-shadow: ${({ theme }) => `inset 0 0 0 1px ${theme.colors.neutral['200']}`};
        color: ${({ theme }) => theme.colors.neutral['400']};
        border-radius: ${({ theme }) => `${theme.radii.medium}px`};
        pointer-events: none;
      }
    }
  }
`;
